// @flow
import React from "react";
import Loadable from "react-loadable";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import createHistory from "history/createBrowserHistory";
import { Switch } from "react-router-dom";
import { Router } from "react-router";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import ReduxToastr from "react-redux-toastr";

import ModalsRoot from "components/globalModals";
import { RouteListener, TransProvider } from "partialComponents";

import reducers from "ducks/index";
import { authInitWorker } from "ducks/auth/actions";
import { cartInitWorker } from "ducks/cart/actions";
import { initLanguageWorker } from "ducks/ui/actions";
import { ErrorBoundary, Loader, Error404 } from "components";
import { AnimRoute, AuthRoute } from "components/routes";

import Login from "pages/login/Login";
import Logout from "pages/logout/Logout";
import PasswordReset from "pages/password/Reset";
import PasswordConfirm from "pages/password/confirm";
import Tutorial from "pages/tutorial";

export const history = createHistory();
const middleware = [thunk, routerMiddleware(history)];
let devtools;
let composedMiddleware;
if (process.env.NODE_ENV === "production" || !window.__REDUX_DEVTOOLS_EXTENSION__) {
  composedMiddleware = applyMiddleware(...middleware);
} else {
  devtools = window.__REDUX_DEVTOOLS_EXTENSION__();
  composedMiddleware = compose(applyMiddleware(...middleware), devtools);
}

export const store = createStore(reducers, composedMiddleware);

const loader = () => <Loader large={true} absolute={true} />;
const Content = Loadable({
  loader: () => import("routeContainers/Content"),
  loading: loader,
});

class App extends React.Component<any> {
  constructor() {
    super();
    store.dispatch(initLanguageWorker());
    store.dispatch(authInitWorker());
    store.dispatch(cartInitWorker());
  }

  render() {
    return (
      <Provider store={store}>
        <TransProvider debug={false}>
          <div>
            <Router history={history}>
              <ErrorBoundary>
                <RouteListener />
                <Switch>
                  <AnimRoute exact path="/login" component={Login} />
                  <AnimRoute exact path="/logout" component={Logout} />
                  <AnimRoute exact path="/password/reset" component={PasswordReset} />
                  <AnimRoute
                    exact
                    path="/password/confirm/:uid/:token"
                    component={PasswordConfirm}
                  />
                  <AnimRoute exact path="/tutorial" component={Tutorial} />
                  <AuthRoute path="/" component={Content} />{" "}
                  {/* required authentication; container */}
                  <AnimRoute path="*" component={Error404} />
                </Switch>
                <ModalsRoot />
              </ErrorBoundary>
            </Router>
            <ReduxToastr
              timeOut={6000}
              newestOnTop={false}
              preventDuplicates={false}
              position="top-center"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
            />
          </div>
        </TransProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js